

import React from "react";

import { useDispatch } from "react-redux";
import { useRouteMatch,Switch, Route } from "react-router-dom";
import {  Link  } from "react-router-dom";
import { useSelector } from "react-redux";
import {Activity,Settings,MonitorPlay } from 'lucide-react';
const CardCourseMinimized = ({selectCoursePopUp,number,course,icon,arrow,alt,title,details,AppToken,totalCourses}) =>{
    const {url}=useRouteMatch();
    const dispatch = useDispatch();
const currentToken = useSelector((state)=>state?.user?.user?.token);
    const setCurrentAppToken=()=>{
        dispatch({
            type: "UPDATE_APP_TOKEN",
            
            payload:AppToken
          });  
    }
    const setCurrentCourse=()=>{
        dispatch({
            type: "COURSEDATA",
            
            payload:course
          });  
    }
    
return(<><div>
<div align="center" class="card-big-long-app-course-outer" style={{border:"0px solid #fff",marginTop:"50px",background:"#ffffff"}}>
<div  className={`card-big-long-app-course-top `} >
<div  className="create-card-title" style={{textAlign: "left",padding:"10px",color:"#444444"}}>
                   Course {number} : {title} 
                  
                   </div>  <div onClick={()=>{setCurrentCourse();selectCoursePopUp(false)}}  className="create-card-icon-top" >
                          
                           {currentToken?
                           <Link to={`/dashboard/create-course/course-name`}> <Settings style={{padding:"10px"}} color="#958FDA" size="20"/></Link> 
                          :<Link to={`/create-course/course-name`}> <Settings style={{padding:"10px"}} color="#958FDA" size="20"/></Link> 
                           }
                         
                         </div>
                   </div> 
        <div  className={`  `} >
        <div  className={` `} >
               <div className=""  style={{margin:'10px',marginTop:'15px',
                    background:"",borderRadius:"15px"}}>
              <button onClick={()=>{setCurrentCourse();selectCoursePopUp(false)}}  className="AppCardsCourseButtonTwo"   style={{borderRadius:"10px"}}
    >  Set This Course </button>  </div>  </div> </div></div>
                
                </div>

</>)
}
export default CardCourseMinimized;